import React from "react"
import { Box, Typography, Skeleton } from "@mui/material"
import { ReactComponent as FeaturedIcon } from "../../../../assets/images/KnowledgeBase/featured-Icon.svg"
import { ReactComponent as Like } from "../../../../assets/images/like.svg";
const getColumns = (viewMode) => {
    switch (viewMode) {
        case "mobile": return 1;
        case "tab": return 2;
        default: return 3;
    }
};

const getFlexBasis = (viewMode) => {
    switch (viewMode) {
        case "mobile": return "0 0 100%";
        case "tab": return "0 0 calc(50% - 8px)";
        default: return "0 0 calc(33.333% - 12px)";
    }
};

export function FeaturedArticles({ brandColor, accentColor, articles = [], loading, viewMode = "web", fontFamily }) {
    const isMobile = viewMode === "mobile";
    const flexBasis = getFlexBasis(viewMode);
    const columns = getColumns(viewMode);

    if (loading) {
        return (
            <Box sx={{ mb: 4 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: isMobile ? 2 : 3 }}>
                    <Skeleton variant="text" width={isMobile ? 150 : 200} height={32} />
                </Box>
                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                    {Array.from({ length: columns }).map((_, item) => (
                        <Box
                            key={item}
                            sx={{
                                backgroundColor: "#FBFCFC",
                                borderRadius: 1,
                                border: "1px solid #E5E9EC",
                                p: 2,
                                display: "flex",
                                flexDirection: "column",
                                minWidth: isMobile ? "100%" : 200,
                                height: isMobile ? 140 : 170,
                                flex: flexBasis,
                            }}
                        >
                            <Skeleton variant="circular" width={32} height={32} sx={{ mb: 2 }} />
                            <Skeleton variant="text" width="80%" height={20} sx={{ mt: 1 }} />
                            <Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />
                            <Skeleton variant="text" width="100%" height={15} />
                            <Skeleton variant="text" width="90%" height={15} />
                        </Box>
                    ))}
                </Box>
            </Box>
        );
    }

    if (!articles || articles.length === 0) {
        return null;
    }

    return (
        <Box sx={{ mb: 4 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: isMobile ? 2 : 3 }}>
                <Typography
                    sx={{
                        fontSize: isMobile ? 16 : 20,
                        fontWeight: 700,
                        color: "#0C141B",
                        fontFamily: `${fontFamily || "Inter"} !important`,
                        lineHeight: "normal",
                    }}
                >
                    Featured Articles
                </Typography>
            </Box>

            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                {articles.map((article) => (
                    <Box
                        key={article.id}
                        sx={{
                            backgroundColor: "#FBFCFC",
                            borderRadius: 1,
                            border: "1px solid #E5E9EC",
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            minWidth: isMobile ? "100%" : 200,
                            height: isMobile ? 140 : 170,
                            flex: flexBasis,
                            transition: "all 0.2s ease",
                            cursor: "pointer",
                            boxSizing: "border-box",
                            "&:hover": {
                                borderColor: brandColor,
                                boxShadow: `0 2px 8px ${brandColor}20`,
                            },
                        }}
                    >
                        <FeaturedIcon />
                        <Typography
                            sx={{
                                fontSize: isMobile ? 11 : 12,
                                fontWeight: 700,
                                color: "#0C141B",
                                mt: isMobile ? '14px' : '20px',
                                mb: 1,
                                fontFamily: `${fontFamily || "Inter"} !important`,
                                lineHeight: "16.867px",
                                width: '100%',
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                            }}
                        >
                            {article.title}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: 7,
                                color: "#405261",
                                lineHeight: "11.906px",
                                mb: 2,
                                flex: 1,
                                fontFamily: `${fontFamily || "Inter"} !important`,
                                fontWeight: 400,
                                width: '100%',
                            }}
                        >
                            Manage your live chat, Instagram, Whatsapp, and Messenger in a single place
                        </Typography>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography sx={{ fontSize: 7, color: accentColor || brandColor, fontWeight: 600, fontFamily: `${fontFamily || "Inter"} !important` }}>
                                {article?.views || 0} VIEWS
                            </Typography>
                            <Box sx={{ display: "flex", alignItems: "center", gap: '2px' }}>

                                <Like width="12" height="12" viewBox="0 0 24 24" />
                                <Typography
                                    sx={{ fontWeight: "600", fontFamily: `${fontFamily || "Inter"} !important`, fontSize: "7px", lineHeight: '11px' }}
                                >
                                    {article.score || 0}%
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}
